import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BookOpen, Sparkles, ArrowRight } from "lucide-react";

export const MyAccess = () => {
  const [access, setAccess] = useState(null);
  useEffect(() => {
    api.get("/me/access").then((r) => setAccess(r.data)).catch(() => setAccess(null));
  }, []);
  if (!access || (!access.aventure && !access.jeu)) return null;
  return (
    <div className="mt-10" data-testid="my-access">
      <h3 className="font-serif text-2xl text-[#1F2A24]">Mes accès débloqués</h3>
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {access.aventure && (
          <Link to={access.adventure_id ? `/aventure/${access.adventure_id}` : "/aventures"} data-testid="access-aventure"
            className="rounded-xl bg-white border border-[#E8DCC4] p-4 flex items-center justify-between hover:border-[#C9A24B]/60 transition-colors">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-[#385E3A]/12 text-[#385E3A] flex items-center justify-center"><BookOpen size={18} /></span>
              <div><p className="font-serif text-lg text-[#1F2A24]">L'Aventure</p><p className="font-sans text-xs text-[#1F2A24]/50">Reprendre mon voyage</p></div>
            </div>
            <ArrowRight size={18} className="text-[#C9A24B]" />
          </Link>
        )}
        {access.jeu && (
          <Link to="/jeu/ile" data-testid="access-jeu"
            className="rounded-xl bg-white border border-[#E8DCC4] p-4 flex items-center justify-between hover:border-[#C9A24B]/60 transition-colors">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-[#2E5B7F]/12 text-[#2E5B7F] flex items-center justify-center"><Sparkles size={18} /></span>
              <div><p className="font-serif text-lg text-[#1F2A24]">Le Jeu</p><p className="font-sans text-xs text-[#1F2A24]/50">Les 21 cartes illustrées</p></div>
            </div>
            <ArrowRight size={18} className="text-[#C9A24B]" />
          </Link>
        )}
      </div>
    </div>
  );
};
